<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiLock } from "@mdi/js";
export default {
  name: "MdiLock",
  data() {
    return {
      svgPath: mdiLock,
    };
  },
};
</script>
